import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useTranslation } from "react-i18next";

const PopUp = () => {
  const setCasinoBefore = useContextSelector(AuthContext, (ctx) => {
    return ctx.setCasinoBefore;
  });
  const { t } = useTranslation();

  return ReactDOM.createPortal(
    <div className="cdk-overlay-container">
      <div className="cdk-overlay-backdrop dialog-backdrop cdk-overlay-backdrop-showing" />
      <div
        className="cdk-global-overlay-wrapper"
        dir="ltr"
        style={{
          "-webkit-box-pack": "center",
          "-webkit-justify-content": "center",
          "-ms-flex-pack": "center",
          "justify-content": "center",
          "-webkit-align-items": "center",
          "-webkit-box-align": "center",
          "-ms-flex-align": "center",
          "align-items": "center",
        }}
      >
        <div
          id="cdk-overlay-2"
          className="cdk-overlay-pane dialog-panel"
          style={{ position: "static" }}
        >
          <app-dialog _nghost-serverapp-c33280995>
            <div _ngcontent-serverapp-c33280995 className="popup" id="dialog-2">
              <div
                _ngcontent-serverapp-c33280995
                className="popup__header"
              ></div>
              <div _ngcontent-serverapp-c33280995 className="popup__content">
                <app-notify-info
                  _nghost-serverapp-c4275207528
                  className="ng-tns-c4275207528-286 ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c4275207528
                    id="popInbox"
                    className="pop-wrap ng-tns-c4275207528-286 ng-trigger ng-trigger-popWrapTriggerAni show ani ng-star-inserted"
                  >
                    <a
                      onClick={() => setCasinoBefore(false)}
                      _ngcontent-serverapp-c4275207528
                      className="btn-close ng-tns-c4275207528-286"
                      style={{
                        "mask-image": 'url("/assets/Other/icon-close.svg")',
                      }}
                    />
                    <div
                      _ngcontent-serverapp-c4275207528
                      className="pop-title ng-tns-c4275207528-286"
                    >
                      <h3
                        _ngcontent-serverapp-c4275207528
                        className="ng-tns-c4275207528-286"
                      >
                        {" "}
                        {t("Notification")}{" "}
                      </h3>
                    </div>
                    <div
                      _ngcontent-serverapp-c4275207528
                      className="pop-inner content-style ng-tns-c4275207528-286"
                    >
                      <p
                        _ngcontent-serverapp-c4275207528
                        className="ng-tns-c4275207528-286"
                      >
                        {t("Pleaselogtoplaythegame")}
                      </p>
                      <app-login-regisrer-button
                        _nghost-serverapp-c3862670099
                        className="ng-star-inserted"
                      >
                        <div
                          _ngcontent-serverapp-c3862670099
                          className="login-register-button btn-box ng-star-inserted"
                        >
                          <div
                            _ngcontent-serverapp-c3862670099
                            className="button btn-secondary login-button"
                          >
                            <Link to="/login" _ngcontent-serverapp-c3862670099>
                              {" "}
                              {t("Login")}{" "}
                            </Link>
                          </div>
                          <div style={{background:"#2a3838"}}
                            _ngcontent-serverapp-c3862670099
                            className="button btn-primary register-button"
                          >
                            <Link
                              to="/register"
                              _ngcontent-serverapp-c3862670099
                            >
                              {" "}
                              {t("Singup")}{" "}
                            </Link>
                          </div>
                        </div>
                      </app-login-regisrer-button>
                    </div>
                  </div>

                  <div
                    _ngcontent-serverapp-c4275207528
                    className="pop-bg ng-trigger ng-trigger-popBgTriggerAni ng-tns-c4275207528-286 ng-star-inserted"
                    style={{ display: "block" }}
                  />
                </app-notify-info>
              </div>
            </div>
          </app-dialog>
        </div>
      </div>
    </div>,
    document.getElementById("overlay"),
  );
};

export default PopUp;
